import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
//import ElementUI from 'element-ui'
import axios from 'axios'

import Nprogress from 'nprogress' //进度条
import 'nprogress/nprogress.css'

import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/global.css'
// 导入字体图标样式
import './assets/fonts/iconfont.css'
import './assets/fontss/iconfont.css'
import './assets/fontssss/iconfont.css'
import './assets/fontsssss/iconfont.css'

import {Button,Form,FormItem,Input,Message,
Container,Header,Aside,Main,Menu,Submenu,MenuItem,
Breadcrumb,BreadcrumbItem,Card,Row,Col,Table,TableColumn,
Switch,Tooltip,Pagination,Dialog,Notification,Checkbox,
InputNumber,Avatar,CheckboxGroup,Popover,Tag,Popconfirm,
Dropdown,DropdownMenu,DropdownItem,Tabs,TabPane,Loading,
Select,Option,Badge,DatePicker,Upload,Link, Alert} from 'element-ui'



import VueClipboard from 'vue-clipboard2'
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)


axios.defaults.baseURL = 'https://agent.7ccccccc.com/api/'

// axios.defaults.baseURL = 'http://localhost:5000/api/'



axios.interceptors.request.use(config => {
  Nprogress.start()
  config.headers.Authorization = window.sessionStorage.getItem('token')
  return config
})

axios.interceptors.response.use(config => {
  Nprogress.done()
  if (config.data && config.data.meta) {
    if(config.data.meta.status === -2 || config.data.meta.status === -3 || config.data.meta.status === -5){
      window.sessionStorage.removeItem("token");
      window.localStorage.removeItem("token");
      console.log('登录状态失效-跳转');
      vm.$notify.error({title: '错误', message:config.data.meta.msg});
      vm.$router.push('/login')
    }
  }
  return config
})

Vue.prototype.$bus = new Vue()//事件总线
Vue.prototype.$http = axios
Vue.config.productionTip = false

//Vue.use(ElementUI)
Vue.use(Link)
Vue.use(Upload)
Vue.use(Button)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.prototype.$message = Message
Vue.use(Container)
Vue.use(Header)
Vue.use(Main)
Vue.use(Aside)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Card)
Vue.use(Row)
Vue.use(Col)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Switch)
Vue.use(Tooltip)
Vue.use(Pagination)
Vue.use(Dialog)
Vue.prototype.$notify = Notification
Vue.use(Checkbox)
Vue.use(InputNumber)
Vue.use(Avatar)
Vue.use(CheckboxGroup)
Vue.use(Popover)
Vue.use(Tag)
Vue.use(Popconfirm)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Tabs)
Vue.use(TabPane)
//Vue.prototype.$Loading = Loading
Vue.use(Loading)
Vue.use(Select)
Vue.use(Option)
Vue.use(Badge)
Vue.use(DatePicker)
Vue.use(Alert)
var vm = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

/**
 * 1.欢迎(笑脸)
 * 2.数据大屏()
 * 3.项目管理
 * 4.卡密管理
 * 5.用户管理
 * 6.高级功能
*/